function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "150",
  height: "150",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75 19.81a4.245 4.245 0 100-8.49 4.245 4.245 0 000 8.49zM15.566 79.246a4.245 4.245 0 100-8.491 4.245 4.245 0 000 8.49zM134.434 79.246a4.245 4.245 0 100-8.491 4.245 4.245 0 000 8.49zM75 138.679a4.245 4.245 0 100-8.49 4.245 4.245 0 000 8.49z",
  fill: "#000",
  fillOpacity: ".1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75 24.057l2.83 49.528h-5.66L75 24.057zM100.045 100.045L74.028 78.031l4.003-4.002 22.014 26.016z",
  fill: "#AFB9C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75 80.66a5.66 5.66 0 100-11.32 5.66 5.66 0 000 11.32z",
  fill: "#C5CFD6"
})));